// ============================================================================
// medicAppointmentsRenderer.tsx — ПРИЛОЖЕНИЕ «Запись на приём».
//
// Точка входа кабинета записи пациента/врача в оболочке «Предприятие» и
// конфигураторе (/designer/app/medic_appointments). Рендерер регистрируется
// клиентом по коду; серверный объект kind='app' не требуется. Доступ — роли
// пациента и клинические роли (серверные права на объекты — SSoT).
// ============================================================================

import { registerAppRenderer, type AppManifest, APPSDK_VERSION } from '@/lib/apps/sdk';
import { MedicAppointmentsPage } from '@/components/medic/appointments/MedicAppointmentsPage';
import { MEDIC_APPOINTMENTS_APP_CODE } from '@/lib/medicAppointments';
import { canUseMedicAppointments, useSecurityAccess } from '@/lib/securityRoles';

function MedicAppointmentsApp() {
  const access = useSecurityAccess();
  if (!canUseMedicAppointments(access)) {
    return (
      <div className="flex h-full items-center justify-center p-6">
        <div className="max-w-md rounded-xl border bg-card p-5 text-center">
          <div className="text-sm font-medium">Запись на приём недоступна</div>
          <div className="mt-1 text-xs text-muted-foreground">
            Кабинет открыт пациенту (роль «Пациент»), врачу и регистратору
            («Врач», «Медицинский регистратор») и специалистам психологии.
            Роли назначает администратор базы.
          </div>
        </div>
      </div>
    );
  }
  return <MedicAppointmentsPage />;
}

export const MEDIC_APPOINTMENTS_MANIFEST: AppManifest = {
  code: MEDIC_APPOINTMENTS_APP_CODE,
  name: MEDIC_APPOINTMENTS_APP_CODE,
  synonym: 'Запись на приём',
  appKind: MEDIC_APPOINTMENTS_APP_CODE,
  area: 'full',
  apiVersion: APPSDK_VERSION,
  permissions: ['data:read', 'data:write'],
};

export function registerMedicAppointmentsApp(): void {
  registerAppRenderer({
    appKind: MEDIC_APPOINTMENTS_APP_CODE,
    code: MEDIC_APPOINTMENTS_APP_CODE,
    title: 'Запись на приём',
    Component: MedicAppointmentsApp,
    manifest: MEDIC_APPOINTMENTS_MANIFEST,
  });
}
